import { z } from "zod"
import type { ColumnSizing } from "@/lib/column-widths"

export const COLUMNS = [
  "page",
  "aircraft",
  "date",
  "route",
  "hours",
  "defects",
  "flagged",
  "created",
  "updated",
] as const

export const columnSchema = z.enum(COLUMNS)

export type Column = z.infer<typeof columnSchema>

export type Slot = Column | "status" | "actions"

export const COLUMN_LABELS: Record<Column, string> = {
  page: "Page serial no.",
  aircraft: "Aircraft",
  date: "Date",
  route: "Route",
  hours: "Hours",
  defects: "Defects",
  flagged: "To check",
  created: "Created",
  updated: "Updated",
}

export const COLUMN_SIZING: ColumnSizing<Slot> = {
  id: "tech-logs",
  widths: {
    page: 8,
    status: 2,
    aircraft: 9,
    date: 5.5,
    route: 12,
    hours: 4.5,
    defects: 4.5,
    flagged: 5,
    created: 6.5,
    updated: 6.5,
    actions: 3.25,
  },
  fill: "route",
  pinned: ["status", "actions"],
  extras: ["status", "actions"],
  dropOrder: ["updated", "created", "hours", "route", "defects", "date"],
}

export function slotsOf(columns: Column[], withStatus: boolean): Slot[] {
  const rest = columns.filter((column) => column !== "page")
  const status: Slot[] = withStatus ? ["status"] : []
  return ["page", ...status, ...rest, "actions"]
}

export const END_COLUMNS: Column[] = ["hours", "defects", "flagged"]

export const SORTS = ["date", "page"] as const

export const sortSchema = z.enum(SORTS)

export type Sort = z.infer<typeof sortSchema>

export const SORTED: Partial<Record<Column, Sort>> = {
  page: "page",
  date: "date",
}

export const GROUPINGS = ["status", "aircraft", "entered_by"] as const

export const groupingSchema = z.enum(GROUPINGS)

export type Grouping = z.infer<typeof groupingSchema>

export const groupChoiceSchema = z.enum([...GROUPINGS, "none"])

export const GROUPING_LABELS: Record<Grouping, string> = {
  status: "Status",
  aircraft: "Aircraft",
  entered_by: "Entered by",
}
